import API from "@constants/API";

const BASE_URL = "https://api.dev.daily.co.id/point/v2/dashboard/points/";

export const getCoinByIdApi = async (id: string | undefined) => {
  const response = await API.HTTP.get(BASE_URL + "?userId=" + id);
  return response.data;
};
